"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.verifyThirdStepSchema = exports.verifySecondaryReasonSchema = exports.verifyPrimaryReasonSchema = void 0;
var yup = __importStar(require("yup"));
var types_1 = require("./types");
exports.verifyPrimaryReasonSchema = yup.object({
    primaryReason: yup.string(),
});
exports.verifySecondaryReasonSchema = yup.object({
    secondaryReason: yup.string().required(),
    effectiveDate: yup
        .string()
        .notRequired()
        .nullable(true)
        .when('primaryReason', {
        is: function (primaryReason) { return primaryReason !== types_1.PrimaryReason.LOST_TO_BOR; },
        otherwise: yup.string().required().nullable(false),
    }),
});
exports.verifyThirdStepSchema = yup.object().shape({
    billingChanges: yup.object().required(),
    effectiveDate: yup.string().required().nullable(true),
    status: yup.string().required(),
});
